export const awsCommentFileUploadConfig: any = {
  bucketName: process.env.REACT_APP_BUCKET_COMMENT_FILE_ATTACHMENT,
  region: process.env.REACT_APP_REGION,
  accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
  s3Url: 'https://b4igo-comments-attachments.s3.amazonaws.com',
}
